(() => {
  const debounce = (fn, delay = 180) => {
    let timer;
    return (...args) => { clearTimeout(timer); timer = setTimeout(() => fn(...args), delay); };
  };

  const closeAll = (except) => {
    document.querySelectorAll('[data-scg-predictive-results]').forEach((el) => {
      if (el !== except) { el.hidden = true; el.innerHTML = ''; }
    });
  };

  document.querySelectorAll('[data-scg-predictive-search]').forEach((form) => {
    const input = form.querySelector('input[type="search"]');
    const results = form.querySelector('[data-scg-predictive-results]');
    if (!input || !results) return;
    let controller;

    const search = debounce(async () => {
      const q = input.value.trim();
      if (q.length < 2) { results.hidden = true; results.innerHTML = ''; return; }
      if (controller) controller.abort();
      controller = new AbortController();
      const base = (window.Theme && window.Theme.routes && window.Theme.routes.predictive_search_url) || '/search/suggest';
      const params = new URLSearchParams({
        q,
        'resources[type]': 'product,collection,query',
        'resources[limit]': '6',
        'resources[options][unavailable_products]': 'hide',
        section_id: 'predictive-search'
      });
      try {
        const response = await fetch(`${base}?${params.toString()}`, { signal: controller.signal, headers: { 'X-Requested-With': 'XMLHttpRequest' } });
        if (!response.ok) throw new Error('Predictive search request failed');
        const html = await response.text();
        results.innerHTML = html;
        results.hidden = !html.trim();
        closeAll(results);
      } catch (err) {
        if (err.name !== 'AbortError') { results.hidden = true; results.innerHTML = ''; }
      }
    });

    input.addEventListener('input', search);
    input.addEventListener('focus', () => { if (results.innerHTML.trim()) results.hidden = false; });
    input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { results.hidden = true; input.focus(); }
      if (event.key === 'ArrowDown' && !results.hidden) {
        const first = results.querySelector('a, button');
        if (first) { event.preventDefault(); first.focus(); }
      }
    });
    form.addEventListener('focusout', () => setTimeout(() => {
      if (!form.contains(document.activeElement)) results.hidden = true;
    }, 120));
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-scg-predictive-search]')) closeAll();
  });

  document.querySelectorAll('[data-scg-search-sort]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      if (select.value) url.searchParams.set('sort_by', select.value); else url.searchParams.delete('sort_by');
      window.location.assign(url.toString());
    });
  });

  // Hide known importer/supplier artifacts that should never be customer-facing.
  const unwantedLabels = new Set(['books by splitshops', 'getbooks_book', 'charging only']);
  document.querySelectorAll('a, label, option, span').forEach((el) => {
    const text = (el.textContent || '').trim().toLowerCase();
    if (text.includes('report copyright infringement')) {
      const link = el.closest('a');
      if (link) link.remove();
    }
    if (unwantedLabels.has(text)) {
      const row = el.closest('li, .filter-item, .faceted-filter__value, .filter-item--list');
      if (row) row.hidden = true;
    }
  });

})();
